export default __webpack_public_path__ + "static/media/close-tab.ee48df47.svg";